enum ROUTE_ENUM {
  HOME = "/",
  LOGIN = "/",
  DASHBOARD= "/dashboard",
}

export default ROUTE_ENUM;
